import axios from 'axios';
import { baseStrapiURL } from '../config';

const strapiClient = axios.create({
    baseURL: baseStrapiURL,
    timeout: 30000, // 30 secondes
    headers: {
        'Content-Type': 'application/json',
        'X-Frontend-URL': window.location.origin,
    }
});


// Liste des endpoints qui nécessitent une authentification
const PROTECTED_ENDPOINTS = [
    '/api/users/me',
    '/api/user/profile',
    '/api/user/change-password',
    '/api/workshops/user',
    '/api/trainings/user',
    '/api/trainings/my-trainings',
    '/api/trainings/',
    '/api/progress/',
    // Ajouter d'autres endpoints protégés selon vos besoins
];

// Fonction pour vérifier si l'endpoint nécessite une authentification
const isProtectedEndpoint = (url) => {
    return PROTECTED_ENDPOINTS.some(endpoint => url.includes(endpoint));
};

// Intercepteur pour ajouter conditionnellement le token d'authentification
strapiClient.interceptors.request.use(
    (config) => {
        // Vérifier si l'endpoint nécessite une authentification
        if (isProtectedEndpoint(config.url)) {
            const token = localStorage.getItem('strapiToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        
        // Permettre l'override manuel du token via les headers
        if (config.requireAuth === true) {
            const token = localStorage.getItem('strapiToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        
        return config;
    },
    (error) => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Intercepteur pour gérer les erreurs d'authentification
strapiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Si le token est expiré ou invalide (401) et que c'était une requête protégée
        if (error.response?.status === 401 && isProtectedEndpoint(error.config?.url)) {
            localStorage.removeItem('strapiToken');
            localStorage.removeItem('strapiUser');
            
            // Rediriger vers la page de connexion si on n'y est pas déjà
            if (window.location.pathname !== '/connexion') {
                window.location.href = '/connexion';
            }
        }
        
        return Promise.reject(error);
    }
);

export default strapiClient;